import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { navigationlessRoutes } from '../OpalRoutes'
import { pathMatchesRoutes } from '../pathMatchesRoutes'

/**
 * Checks the current route against routes that should not
 * display the navigation sidebar.
 */
export const useNavigationlessRoute = (): boolean => {
  const { pathname } = useLocation()

  return useMemo(
    () => pathMatchesRoutes(navigationlessRoutes, pathname),
    [pathname]
  )
}
